import momentTz from 'moment-timezone';

// these functions are here because its easiest to use the iOS date/time picker
// components in the local timezone. So if a user is in a different timezone
// than that configured on the event, those UI components will return date
// objects in their local time. So we need to take the hours/mins,date that the
// user configured and create a new date object with those values but in the
// configured timezone. Likewise when a user view the event from in a different
// timezone than that configured on the event, we will set a date in local time
// on the UI component as the selected date, so we need to set the
// date/hours/mins to those of the configured timeZone so it will display
// at the time in that timezone instead of displaying in the actual local time
// when it will occur.

// take the date/time in the provided timezone, and return a date in the local
// timezone of the user that looks the same (same day, hours, minutes, etc)
export function convertDateFromTZ(date, timeZone) {
  // don't fail hard if we got a string instead of Date object
  if (typeof date === 'string') {
    date = new Date(date);
  }
  let dateInOrigTZ = momentTz(date.toISOString()).tz(timeZone);
  let dateTimeWithoutZone = dateInOrigTZ.format('YYYY-MM-DD HH:mm');
  let dateConverted = momentTz(dateTimeWithoutZone);
  return dateConverted.toDate();
}

// take the date/time in the local timezone of the user and return a date in the
// provided timeZone that looks the same (same day, hours, minutes, etc)
export function convertDateToTZ(date, timeZone) {
  // don't fail hard if we got a string instead of Date object
  if (typeof date === 'string') {
    date = new Date(date);
  }
  let dateInOrigTZ = momentTz(date.toISOString());
  let dateTimeWithoutZone = dateInOrigTZ.format('YYYY-MM-DD HH:mm');
  let dateConverted = timeZone
    ? momentTz.tz(dateTimeWithoutZone, timeZone)
    : momentTz(dateTimeWithoutZone);
  return dateConverted.toDate();
}
